<div class="container-fluid">
    <app-pagetitle title="E-Stamp Customer Orders" [subtitle]="'Create or upload E-Stamp orders'">
    </app-pagetitle>
    <div class="row justify-content-center">
        <div class="col-lg-10 col-md-10 col-sm-12">
            <app-loader [loading]="loadConfig"></app-loader>

            <div class="card shadow-sm" [class.loading-content]="loadConfig">
                <div class="card-body">

                    <div class="tab-pane-custom">

                        <app-api-validation-message [error]="apiValidationError" title="Unable to create customer order"
                            [dismissible]="true" (dismissed)="clearApiValidationMessage()">
                        </app-api-validation-message>

                        
                        <form [formGroup]="orderForm" (ngSubmit)="onSubmit()">

                            <!-- State -->
                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">State <span class="text-danger">*</span></label>
                                        <select class="form-select" formControlName="stateId">
                                            <option value="" [disabled]="true">Select State</option>
                                            <option *ngFor="let state of states" [value]="state._id">
                                                {{ state.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">Stamp Value <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="denomination"
                                            placeholder="Enter Denomination Amount"
                                            (keypress)="allowInput($event, 'number')">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">First Party <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" formControlName="firstParty"
                                            [readonly]="true" placeholder="Enter First Party Name"
                                            (keypress)="allowInput($event, 'text')">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">Second Party <span
                                                class="text-danger">*</span></label>

                                        <input type="text" class="form-control" formControlName="secondParty"
                                            placeholder="Enter Second Party Name"
                                            (keypress)="allowInput($event, 'text')">
                                    </div>
                                </div>
                            </div>

                            <!-- Purpose -->
                            <div class="mb-3">
                                <label class="form-label">Purpose <span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="purpose"
                                    placeholder="Enter purpose">
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">Append Stamp Position <span
                                                class="text-danger">*</span></label>
                                        <select class="form-select" formControlName="appendStampPosition">
                                            <option value="" [disabled]="true">Select</option>
                                            <option value="PRE">Pre</option>
                                            <option value="POST">Post</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- File Upload -->
                                <div class="col-6">
                                    <div class="mb-3">
                                        <label class="form-label">Upload Required Document <span
                                                class="text-danger">*</span></label>
                                        <input #fileInput type="file" class="form-control" accept="application/pdf,.pdf"
                                            (change)="onFileSelect($event)">
                                        <div class="form-text">Only the required document in PDF format is allowed. Max
                                            file size: 10MB</div>
                                        <div *ngIf="fileSizeError" class="text-danger mt-1">
                                            <small>
                                                <i class="fas fa-exclamation-circle me-1"></i>
                                                {{ fileSizeError }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="d-grid mt-3">
                                <button type="submit" class="btn btn-primary" [disabled]="loading || orderForm.invalid">
                                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"
                                        aria-hidden="true"></span>
                                    {{loading ? 'Loading...' : 'Submit Order'}}
                                </button>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
